import { CHART_VIEW_MAPPING } from '@aytm/app/stats/page/question-views/sft/lib/constants'

export const btnsTitle = type => {
  switch (type) {
    case 'fits':
    case 'fitsRev':
      return { y: 'Fit', n: 'Not Fit' }
    case 'thumbs':
    case 'thumbsRev':
      return { y: 'Thumbs Up', n: 'Thumbs Down' }
    case 'yesno':
    case 'noyes':
      return { y: 'Yes', n: 'No' }
    case 'matches':
    case 'matchesRev':
      return { y: 'Match', n: 'Not Match' }
    default:
      return { y: 'Timed Out', n: '' }
  }
}

export const getViewModeList = ({ features }) => {
  const isScatterEnabled = 'on' === features?.rapid_scatter_plot_chart

  return isScatterEnabled ? CHART_VIEW_MAPPING : CHART_VIEW_MAPPING.slice(0, -1)
}
